import useScreenOptionsHooks from "../../../../hooks/useScreenOptionsHooks";
import { SpaceType } from "@components/atoms/Spacer/types";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "@scenes/favorites/utils/collectionSchema";
import Input from "@components/atoms/Input";
import { useState } from "react";
import { VDBIcons } from "@utils/VDBIcons";
import { ProductCategory } from "@utils/constants";
import { useDispatch } from "react-redux";
import { setProductType } from "@redux/slices/appStateSlice";
import {
  removeFiltersPayload,
  setFiltersPayload,
  setSectionName,
  useValueFromPayload,
} from "@redux/slices/searchFilters";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import styled from "styled-components/native";
import { Spacer, VDBText } from "@components/atoms";
import { useTypographyStore } from "@redux/slices/typographySlice";

const SearchStockSection = ({
  sectionTitle,
  productType,
  payloadName,
  sectionName,
  placeholder,
  leftItem,
}: {
  sectionTitle: string;
  productType: ProductCategory;
  payloadName: string[];
  sectionName: string;
  placeholder: string;
  leftItem: string;
}) => {
  const { theme, t } = useScreenOptionsHooks();
  const typography = useTypographyStore();
  const { control } = useForm({
    resolver: yupResolver(schema),
  });
  const value = useValueFromPayload(sectionName, payloadName);

  const [inputValue, setInputValue] = useState(value || "");
  const dispatch = useDispatch();
  const userInfo = useUserInfo();

  const updateFiltersPayload = (text: string) => {
    if (text.length === 0 && sectionName && payloadName) {
      dispatch(removeFiltersPayload({ sectionName, payloadName }));
    } else {
      const actualProductType =
        productType === ProductCategory.LABGROWN_JEWELRY
          ? ProductCategory.JEWELRY
          : productType;
      dispatch(setProductType(actualProductType));
      dispatch(setSectionName(sectionName));
      const payload: any = {};
      payload[payloadName[0]] = text;
      dispatch(setFiltersPayload({ sectionName, data: payload }));
    }
  };

  const getInputComponent = () => {
    return (
      <Controller
        control={control}
        render={({ field: { onChange, onBlur } }) => (
          <Input
            inputLabel={""}
            placeholder={""}
            searchPlaceholder={t(placeholder)}
            returnKeyType="search"
            rightIcon={VDBIcons.MAIN_SEARCH}
            leftIcon={leftItem ?? ""}
            hideIconContainer={false}
            onBlur={onBlur}
            value={inputValue}
            isShownTopPadding={true}
            disableLeftIcon={false}
            onChangeText={(val) => {
              let trimmedValue = val;
              if (
                userInfo?.user?.feature_settings
                  ?.enable_short_title_filter_in_text_search ||
                userInfo?.allowSpaceInGlobalTextSearchFor20()
              ) {
                trimmedValue = val;
              } else {
                trimmedValue = val
                  .replace(/\s+/g, ",")
                  .replace(/,+/g, ",")
                  .replace(/^,/, "");
              }
              const regex = /^[\s\S]*$/;
              if (regex.test(trimmedValue) && trimmedValue[0] !== " ") {
                onChange(trimmedValue);
                setInputValue(trimmedValue);
                updateFiltersPayload(trimmedValue);
              }
            }}
            // leftIconColor={
            //   inputValue.length === 0 ? theme["core-05"] : theme["core-04"]
            // }
          />
        )}
        name="collectionName"
      />
    );
  };

  return (
    <>
      <ParentContainer sectionTitle={sectionTitle}>
        {sectionTitle && (
          <>
            <TitleSection>
              <VDBText
                isBold
                type={typography["H3-M"]}
                color={theme["core-05"]}
              >
                {sectionTitle}
              </VDBText>
              <Spacer size={SpaceType.Extra} />
            </TitleSection>
          </>
        )}
        {getInputComponent()}
      </ParentContainer>
    </>
  );
};

const ParentContainer = styled.View<{ sectionTitle: string }>`
  padding-top: ${({ sectionTitle }) => (sectionTitle ? 0 : SpaceType.Double)}px;
  padding-left: ${SpaceType.Double}px;
  padding-right: ${SpaceType.Double}px;
  padding-bottom: ${SpaceType.ExtraSmall}px;
`;

const TitleSection = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: ${SpaceType.Extra}px;
  padding-bottom: ${SpaceType.Extra}px;
`;

export default SearchStockSection;
